export default "__VITE_ASSET__CQxzHrjq__"